import { MatchTeamForm } from "./components/MatchTeamForm";

export function CreateMatchTeamPage() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Crear Equipo</h2>
        <p className="text-gray-600 mt-1">
          Completa el formulario para registrar un nuevo equipo
        </p>
      </div>
      <MatchTeamForm />
    </div>
  );
}
